import { string } from 'zod'

export const emailValidationSchema = string({ required_error: 'common.validation.mandatory' })
  .min(1, { message: 'common.validation.mandatory' })
  .email({ message: 'common.validation.invalidEmail' })

export const passwordSchema = string({
  required_error: 'common.validation.mandatory',
})
  .min(1, { message: 'common.validation.mandatory' })
  .min(8, { message: 'common.validation.passwordLength' })
